<div [ngClass]="question.styles">
    @for(questionItem of question.questions; track questionItem.key){ @switch(questionItem.controlType) { @case(CONTROL_TYPES.Textbox) {
    <vp-textbox [question]="questionItem | as : TYPES.TextboxQuestion" [form]="$any(form.get(question.groupName))"></vp-textbox>
    } @case(CONTROL_TYPES.Radio) {
    <vp-radio [question]="questionItem | as : TYPES.RadioQuestion" [form]="$any(form.get(question.groupName))"></vp-radio>
    } @case(CONTROL_TYPES.Dropdown) {
    <vp-dropdown [form]="$any(form.get(question.groupName))" [question]="questionItem | as : TYPES.Dropdown"></vp-dropdown>
    } @case(CONTROL_TYPES.Checkbox) {
    <vp-checkbox [question]="questionItem | as : TYPES.CheckboxQuestion" [form]="$any(form.get(question.groupName))"></vp-checkbox>
    } @case(CONTROL_TYPES.Slider) {
    <vp-slider
        [form]="$any(form.get(question.groupName))"
        [formControlName]="(questionItem | as : TYPES.SliderQuestion).key"
        [question]="questionItem | as : TYPES.SliderQuestion"
    ></vp-slider>
    } } }
</div>
